export default __webpack_public_path__ + "static/media/Next_Gen.27111de0.jpeg";